import React, { Component } from 'react';
import Select from '../../../../Part_Sample/Select';
import { makeTimeString, isEmpty } from '../../../../Common/Common';
import Offtimer_icon from '../../../../../Images/Daikin_Images/image/Offtimer.png';

export default class Off_Timer_Duration extends Component {
	constructor(props) {
		super(props);

		let duration = 0;
		if (!isEmpty(this.props.point_info)) {
			duration = this.props.point_info.off_duration;
		}

		this.state = {
			duration: duration,
		}
	}

	handleChangeDuration = (val) => {
		this.setState({ duration: val });
		this.props.handleChangeOffDuration(parseInt(val));
	}

	render() {
		let timerDurations = [];
		for (let i = 0; i <= 720; i += 5) {
			let hour = '00';
			let min = '00';
			let time_string = '';

			if ((i / 60) >= 1) {
				hour = Math.floor(i / 60);
				min = makeTimeString(i % 60);
				time_string = hour + this.props.receiver.getString('hour_short') + ' ' + min + this.props.receiver.getString('min_short');
			} else {
				min = makeTimeString(i);
				time_string = min + this.props.receiver.getString('min_short');
			}

			if (i == this.state.duration) {
				timerDurations.push(<option value={i} selected="selected">{time_string}</option>);
			} else {
				timerDurations.push(<option value={i}>{time_string}</option>);
			}
		}

		return (
			<div id='off_timer_duration' style={this.props.style}>
				<div style={{ padding: 10, }}>
					<div style={{ display: 'inline-block', width: this.props.width - 180 }}>
						<span> {this.props.receiver.getString('off_timer_duration')} </span>
					</div>
					<div style={{ display: 'inline-block', marginLeft: 10, width: 150 }}>
						<Select
							options={timerDurations}
							value={this.state.duration}
							onSelect={this.handleChangeDuration}
						/>
					</div>
				</div>

			</div>
		)
	}
}